export default __webpack_public_path__ + "static/media/Deacon's Legguards of the Hallow Worlds.3e78d0a2.jpg";